module.exports = __webpack_public_path__ + "img/mni.476c7390.svg";